import { findImbeddedKeyValue } from '../../shared/findImbeddedKeyValue';
import { LeaderHighlightInputs } from './LeaderHighlight';
import { getImage } from 'gatsby-plugin-image';

export const leaderHighlightTransformer = (node): LeaderHighlightInputs => {
    const fieldLeader = findImbeddedKeyValue(node, `field_leader`);
    const leaderRel = node.relationships;

    if (fieldLeader) {
        return {
            mainTitle: leaderRel?.field_leader?.title,
            subTitle: leaderRel?.field_leader?.field_leadership_position_title,
            imgData: {
                alt: `${leaderRel?.field_leader?.title}'s headshot`,
                verticalAlign: `top`,
            },
            gImage: getImage(
                leaderRel?.field_leader?.relationships?.field_ldr_headshot
                    ?.localFile
            ),
            isEmbedded: true,
            cta: [
                {
                    title: `View Leadership Profile`,
                    uri: leaderRel?.field_leader?.fields?.url,
                    download: false,
                },
            ],
        };
    }

    return {
        mainTitle: node.field_last_name,
        subTitle: node.field_leadership_position_title,
        imgData: {
            alt: findImbeddedKeyValue(leaderRel, `alt`),
            verticalAlign: `top`,
        },
        gImage: getImage(
            leaderRel?.field_ldr_headshot?.relationships?.field_media_image
                ?.localFile
        ),
        isEmbedded: true,
        cta: node.field_article_link
            ? [
                  {
                      title: `View Leadership Profile`,
                      uri: node.field_article_link.uri,
                      download: false,
                  },
              ]
            : [],
    };
};
